import React from "react"

export default function Introduction() {
  return <div className='font-family-bungee text-6xl text-center my-64 md:text-2xl'>
      <p>Hello,I'm Anno.</p>
      <p>I'm a Web Developer!</p>
      <img
          className="h-96 m-auto md:h-48"
          src={`img/y0581.png`}
          alt="image of Introduction"
      />
  </div>
}
